import {
  CcfBox,
  CcfNoRequestFoundIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './ccf-wem-dashboard.module.scss';
import { CcfWemTable } from './ccf-wem-table';

/* eslint-disable-next-line */
export interface CcfWemShiftBiddingProps {}

/**
 * CcfWemShiftBidding - used to display wem schedule requests
 * @param props - CcfWemShiftBidding
 * @example `<CcfWemShiftBidding />`
 */
export function CcfWemShiftBidding(props: CcfWemShiftBiddingProps) {
  const columns = [
    {
      field: 'biddingDateRange',
      headerName: 'BIDDING DATE RANGE',
      width: 250,
      flex: 1,
    },
    {
      field: 'initiatedBy',
      headerName: 'INITIATED BY',
      width: 370,
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'STATUS',
      width: 250,
      flex: 1,
    },
    {
      field: 'bidSubmitted',
      headerName: 'BID SUBMITTED',
      width: 250,
      flex: 1,
    },
  ];

  /**
   *
   * @example - noDataFound()
   */
  const noBidsFound = () => {
    return (
      <CcfBox className={styles.tableDataContainer}>
        <CcfBox className={styles.noDataFoundBlock}>
          <CcfNoRequestFoundIcon style={{ fontSize: 240 }} />
          <CcfTypography className={styles.noRequestTxt}>
            No bids were generated yet
          </CcfTypography>
        </CcfBox>
      </CcfBox>
    );
  };

  return (
    <CcfBox className={styles.wemScheduleContainer}>
      <CcfBox>
        <CcfTypography className={styles.wemTabTitle}>
          Shift Bidding
        </CcfTypography>
      </CcfBox>
      <CcfWemTable
        columns={columns}
        noDataFound={noBidsFound()}
        tableHeaderText="0 bids"
      />
    </CcfBox>
  );
}
